import {
  ClientStatusEnum,
  ClientStatusTypes,
  ClientTypeEnum,
  ClientTypeTypes,
  IClientStatusDTO,
  IClientTypeDTO,
} from "@hooks/dtos/IClientDTO";

export const clientStatusTypes: IClientStatusDTO[] = [
  {
    status: ClientStatusEnum.ACTIVE,
    text: "Cliente ativo",
    title: "Ativo",
    color: "success",
  },
  {
    status: ClientStatusEnum.INACTIVE,
    text: "Cliente inativo",
    title: "Inativo",
    color: "danger",
  },
  {
    status: ClientStatusEnum.PENDING,
    text: "Cliente pendente",
    title: "Pendente",
    color: "warning",
  },
  {
    status: ClientStatusEnum.DELETED,
    text: "Cliente excluído",
    title: "Excluído",
    color: "danger",
  },
];

export const clientTypes: IClientTypeDTO[] = [
  {
    type: ClientTypeEnum.GUEST,
    text: "Convidado",
    title: "Convidado",
    color: "secondary",
  },
  {
    type: ClientTypeEnum.CLIENT,
    text: "Cliente",
    title: "Cliente",
    color: "info",
  },
];

export function getClientStatus(status: ClientStatusTypes): IClientStatusDTO {
  let ret = clientStatusTypes.find(
    (clientStatus) => clientStatus.status === status,
  );
  if (!ret)
    ret = {
      status: "undefined",
      text: "Status não informado",
      title: "Não informado",
      color: "secondary",
    };
  return ret;
}

export function getClientType(type: ClientTypeTypes): IClientTypeDTO {
  let ret = clientTypes.find((clientType) => clientType.type === type);
  if (!ret)
    ret = {
      type: "undefined",
      text: "Tipo não informado",
      title: "Não informado",
      color: "secondary",
    };
  return ret;
}
